module.exports = __webpack_public_path__ + "static/media/historic_alert_marker_hover.24b18a42.svg";